<div class="w-full sm:flex-none sm:w-full px-2">
    <app-dialog-overlay #keywordsDialog></app-dialog-overlay>
</div>

<div class="flex justify-center">
    <a class="pr-4 section-border-right cursor-pointer" tabindex=""
        [ngClass]="popularKeysTabSelected ? 'a-active font-bold ' : 'a-inactive'"
        (click)="toggleTabs(true)">Popular</a>
    <a class="pl-4 cursor-pointer"
        [ngClass]="!popularKeysTabSelected ? 'a-active font-bold ' : 'a-inactive'" tabindex=""
        (click)="toggleTabs(false)">All Keywords</a>
</div>

<div *ngIf="!popularKeysTabSelected">
    <div class="flex flex-wrap -mx-2" *ngIf="searchType == 'basic'">
        <div class="w-full sm:flex-none sm:w-full px-2">
            <app-chips-selector-form-field-ui
                label="Keywords"
                placeholder="Type here to search"
                [isLoading]="loading"
                [items]="keywords | async"
                [skipItemsCheck]="true"
                [(ngModel)]="specialities"
                (selectionChanged)="onItemAdded('specialties', 'specialities')"
                (searchChanged)="specialitiesInput$.next($event)"
                (triggerSearch)="triggerSearch.emit()"
                [listElementTooltipIfTruncated]="true"
            ></app-chips-selector-form-field-ui>
        </div>

        <div class="w-full sm:flex-none sm:w-full px-2" *ngIf="hasBooleanAttribute">
            <p class="text-primary text-right mt-1 cursor-pointer" (click)="toggleSearchType($event, 'advanced')">Switch to advanced search</p>
        </div>
    </div>

    <div class="flex flex-wrap -mx-2" *ngIf="hasBooleanAttribute && searchType == 'advanced'">
        <div class="w-full sm:flex-none sm:w-full pt-2 px-2">
            <small><b>INCLUDE:</b></small>
        </div>
        <div class="w-full sm:flex-none sm:w-full px-2">
            <app-chips-selector-form-field-ui
                label="ANY of these keywords"
                placeholder="Type here to search"
                [isLoading]="loading_any"
                [items]="keywords_any | async"
                [skipItemsCheck]="true"
                [(ngModel)]="specialities_any"
                (selectionChanged)="onItemAdded('specialties_any', 'specialities_any')"
                (searchChanged)="specialitiesAnyInput$.next($event)"
                (triggerSearch)="triggerSearch.emit()"
                [listElementTooltipIfTruncated]="true"
            ></app-chips-selector-form-field-ui>
        </div>
        <div class="w-full sm:flex-none sm:w-full mt-1 px-2">
            <app-chips-selector-form-field-ui
                label="ALL of these keywords"
                placeholder="Type here to search"
                [isLoading]="loading_all"
                [items]="keywords_all | async"
                [skipItemsCheck]="true"
                [(ngModel)]="specialities_all"
                (selectionChanged)="onItemAdded('specialties_all', 'specialities_all')"
                (searchChanged)="specialitiesAllInput$.next($event)"
                (triggerSearch)="triggerSearch.emit()"
                [listElementTooltipIfTruncated]="true"
            ></app-chips-selector-form-field-ui>
        </div>
        <div class="w-full sm:flex-none sm:w-full mt-1 px-2">
            <app-chips-selector-form-field-ui
                label="NONE of these keywords"
                placeholder="Type here to search"
                [isLoading]="loading_none"
                [items]="keywords_none | async"
                [skipItemsCheck]="true"
                [(ngModel)]="specialities_none"
                (selectionChanged)="onItemAdded('specialties_none', 'specialities_none')"
                (searchChanged)="specialitiesNoneInput$.next($event)"
                (triggerSearch)="triggerSearch.emit()"
                [listElementTooltipIfTruncated]="true"
            ></app-chips-selector-form-field-ui>
        </div>
        <div class="w-full sm:flex-none sm:w-full px-2">
            <p class="text-primary text-right mt-1 cursor-pointer" (click)="toggleSearchType($event, 'basic')">Switch to basic search</p>
        </div>
    </div>
</div>

<div *ngIf="popularKeysTabSelected">
    <div class="flex flex-wrap -mx-2">
        <div class="w-full sm:flex-none sm:w-full px-2">
            <app-chips-selector-form-field-ui
            label="Keywords"
            placeholder="Type here to search"
            [isLoading]="loading_popular"
            [items]="popularKeywordsFiltered"
            [skipItemsCheck]="true"
            [(ngModel)]="specialities_popular"
            (selectionChanged)="onItemAdded('popular_keywords', 'specialities_popular')"
            (searchChanged)="searchPopularKeywords($event)"
            (triggerSearch)="triggerSearch.emit()"
            [listElementTooltipIfTruncated]="true"
        ></app-chips-selector-form-field-ui>
        </div>
    </div>
</div>
